import { RouteName } from '@mews-commander/enums';
import { CommanderThunkAction } from '@mews-commander/types';
import { navigateInModal } from '../../app/actions/common';

export const navigateToRestrictionIndexPage =
    (ownerId: string): CommanderThunkAction =>
    (dispatch, getState, { resolveRoute }) => {
        const restrictionIndexUrl = resolveRoute(RouteName.RestrictionIndex, {
            query: { OwnerId: ownerId },
        });

        dispatch(navigateInModal(restrictionIndexUrl));
    };
